module.exports = __webpack_public_path__ + "static/media/19.714d7330.png";